import React, {
  useState,
  useEffect,
  useReducer,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { FormattedMessage } from 'react-intl';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../../../_metronic/_partials/controls';
import Numeric from '../../../../../../components/Numeric';
import axios, { baseUrl } from '../../../../../../../redux/my-axios';
import OrderBox from './OrderBox';

export const BOXES_URL = '/boxes';
function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return { boxes: action.payload.boxes, items: action.payload.items };
    case 'setboxes':
      return { ...state, boxes: action.payload };
    case 'setitems':
      return { ...state, items: action.payload };
    case 'createbox':
      return {
        boxes: [
          ...state.boxes,
          {
            trackingId: action.payload.trackingId,
            check: action.payload.check,
            items: action.payload.items,
            sortNo: action.payload.sortNo,
          },
        ],
        items: [
          ...state.items.filter((item) => {
            if (
              !action.payload.items.find(
                (c) => c.productCode === item.productCode
              )
            )
              return item;
          }),
        ],
      };
    case 'deletebox':
      return {
        boxes: state.boxes.filter((box) => {
          if (box.trackingId !== action.payload.trackingId) return box;
        }),
        items: [...state.items, ...action.payload.items],
      };
    case 'updateboxcheck':
      return {
        ...state,
        boxes: state.boxes.map((box) => {
          if (box.trackingId === action.payload.trackingId) {
            return { ...box, check: action.payload.check };
          }
          return box;
        }),
      };
    case 'removeboxitem':
      return {
        boxes: state.boxes.map((box) => {
          if (box.trackingId === action.payload.trackingId) {
            return {
              ...box,
              items: box.items.filter((item) => {
                if (item.productCode !== action.payload.item.productCode)
                  return item;
              }),
            };
          }
          return box;
        }),
        items: [...state.items, action.payload.item],
      };
    default:
      throw new Error();
  }
}

const initialState = {
  items: [],
  boxes: [],
};

const Shipping = (props) => {
  const { order, saveBox } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [sortNo, setSortNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  //console.log('ORDERBOXES.Order: ', order);
  useEffect(() => {
    setLoading(true);
    axios
      .post(BOXES_URL, order.orderCode, { headers: { action: 'get' } })
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            console.log('GetBoxes: ', response.data.data);
            dispatch({ type: 'setboxes', payload: response.data.data });
            setLoading(false);
            break;
          default:
            var error = response.data.msg.desc;
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
    axios
      .post(
        BOXES_URL,
        { orderCode: order.orderCode, trackingId: '' },
        { headers: { action: 'getitems' } }
      )
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            console.log('GetItems: ', response.data.data);
            if (response.data.data && response.data.data.length > 0)
              dispatch({ type: 'setitems', payload: response.data.data });
            setLoading(false);
            break;
          default:
            var error = response.data.msg.desc;
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [order]);

  useEffect(() => {
    console.log('SHIPPING', state);
    /* setShippingResult({
      orderCode: order.orderCode,
      boxes: state.boxes,
      items: state.items,
    }); */
    let no = 1;
    if (state.boxes) no = state.boxes.length + 1;
    setSortNo(no);
    setTotalCount(state.boxes.length);
  }, [state.boxes, dispatch]);

  /* useImperativeHandle(
    ref,
    () => ({
      saveBox(orderCode, boxes, items) {
        save(orderCode, boxes, items);
      },
    }),
    []
  ); */

  const save = () => {
    //let result = state;
    console.log('Save:', state);
    if (state.items && state.items.length > 0) {
      setError(
        `${state.items.map((item) => {
          return item.productCode;
        })} гэсэн бүтээгдэхүүнийг хайрцагт хуваарилна уу!`
      );
      return;
    }
    setError('');
    setLoading(true);
    axios
      .post(
        BOXES_URL,
        { orderCode: order.orderCode, boxes: state.boxes },
        { headers: { action: 'set' } }
      )
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            console.log('set boxes: ', response.data.data);
            setError('');
            setMsg('Амжилттай хадгаллаа');
            setLoading(false);
            saveBox(); //for refresh status on title
            break;
          default:
            var error = response.data.msg.desc;
            setMsg('');
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setMsg('');
        setError(error);
        setLoading(false);
      });
  };

  const createBox = (trackingId, check, items, sortNo) => {
    if (trackingId === '') {
      setError('TrackingId -д утга оруулна уу!');
      return;
    }
    if (!items || items.length === 0) {
      setError('Бүтээгдэхүүн сонгоно уу!');
      return;
    }
    setError('');
    dispatch({
      type: 'createbox',
      payload: { trackingId, check, items, sortNo },
    });
  };

  const deleteBox = (trackingId, entities) => {
    setError('');
    dispatch({ type: 'deletebox', payload: { trackingId, items: entities } });
  };

  const updateBoxCheck = (trackingId, check) => {
    if (trackingId === '') {
      setError('TrackingId -д утга оруулна уу!');
      return;
    }
    setError('');

    dispatch({ type: 'updateboxcheck', payload: { trackingId, check } });
  };

  const removeBoxItem = (trackingId, item) => {
    setError('');
    dispatch({ type: 'removeboxitem', payload: { trackingId, item } });
  };

  return (
    <div>
      {error ? (
        <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
          <div className='alert-text font-weight-bold'>{error}</div>
        </div>
      ) : (
        <div></div>
      )}
      {msg ? (
        <div className='mb-10 alert alert-custom alert-light-success alert-dismissible'>
          <div className='alert-text font-weight-bold'>{msg}</div>
        </div>
      ) : (
        <div></div>
      )}
      <Card id='orderBoxesCard'>
        {loading && <ModalProgressBar />}
        <CardHeader title={`Boxes - ${totalCount}`}>
          <CardHeaderToolbar>
            <button
              type='button'
              className='btn btn-success ml-2'
              onClick={save}
            >
              <FormattedMessage id='GENERAL.BUTTON.SAVE' />
              {loading && (
                <span
                  id='orderItemsSave'
                  className='ml-3 spinner spinner-white '
                ></span>
              )}
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {state.items.length > 0 ? (
            <OrderBox
              key='NewOrderBox'
              order={order}
              box={{ trackingId: '', check: false, items: state.items, sortNo }}
              isNew={true}
              createBox={createBox}
              setError={setError}
            />
          ) : (
            <></>
          )}
          {state.boxes &&
            state.boxes.map((box) => (
              <OrderBox
                key={`OrderBox${box.trackingId}`}
                order={order}
                box={box}
                isNew={false}
                deleteBox={deleteBox}
                updateBoxCheck={updateBoxCheck}
                removeBoxItem={removeBoxItem}
                setError={setError}
              />
            ))}
        </CardBody>
      </Card>
    </div>
  );
};
export default Shipping;
//export default forwardRef(Shipping);
